(function () {
  function normalizePath(path) {
    if (!path) return '/';
    return path.length > 1 ? path.replace(/\/+$/, '') : path;
  }

  function closeDrawer() {
    var drawer = document.getElementById('Details-menu-drawer-container');
    if (drawer && drawer.hasAttribute('open')) drawer.removeAttribute('open');
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[data-dd214-home-anchor]');
    if (!link) return;

    var targetId = link.getAttribute('data-dd214-home-anchor');
    var destination;
    try { destination = new URL(link.href, window.location.href); } catch (e) { return; }

    var sameHomePath = destination.origin === window.location.origin &&
      normalizePath(destination.pathname) === normalizePath(window.location.pathname);

    if (!sameHomePath) return;

    var target = document.getElementById(targetId);
    if (!target) return;

    event.preventDefault();
    closeDrawer();

    // Force the movement even when the URL already contains the same hash.
    window.requestAnimationFrame(function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#' + targetId);
      } else {
        window.location.hash = targetId;
      }
    });
  });
})();
